module.exports = __webpack_public_path__ + "static/media/img14.8048e1e9.jpg";